import axios from "axios";
import { Service } from "axios-middleware";
import user from "@/store/modules/user";

const service = new Service(axios);

const needsAPIToken = baseURL => [process.env.API_URL].includes(baseURL);

service.register({
  onRequest(config) {
    if (needsAPIToken(config.baseURL) && localStorage.authentication)
      config.headers.Authorization = `Bearer ${localStorage.authentication}`;
    return config;
  },
  onResponseError(error) {
    if (error.response) {
      const url = error.response.config.url.split("/");
      const endpoint = url[url.length - 1];

      if (error.response.status === 401 && endpoint != "authentication") {
        user.dispatch("logout");
        document.location.reload(true);
      }
    }

    throw error;
  }
});

const withAccept = axios.create({
  baseURL: process.env.API_URL,
  timeout: 30000,
  headers: {
    "Content-Type": "application/vnd.api+json",
    Accept: "application/json"
  }
});

const normal = axios.create({
  baseURL: process.env.API_URL,
  timeout: 30000,
  headers: {
    "Content-Type": "application/vnd.api+json"
  }
});

const cloudinary = axios.create({
  baseURL: process.env.CLOUDINARY_URL,
  timeout: 30000,
  headers: {}
});

const Subscription = axios.create({
  baseURL: "https://donamaid-mail.herokuapp.com/"
});

export default {
  normal,
  withAccept,
  cloudinary,
  Subscription
};



// WEBPACK FOOTER //
// ./src/api/http.js